import {
  createSlice,
  isPending,
  isRejected,
  isFulfilled,
} from '@reduxjs/toolkit';

const initialState = {
  loadingCount: 0,
};

const isExcluded = (action: any) => {
  const name = action?.meta?.arg?.endpointName;
  return (
    name === 'getAdminNotifications' || name === 'getAdminNotificationCount'
  );
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loadingCount += 1;
    },
    stopLoading: (state) => {
      if (state.loadingCount > 0) {
        state.loadingCount -= 1;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state, action) => {
        if (!isExcluded(action)) {
          state.loadingCount += 1;
        }
      })
      .addMatcher(isFulfilled, (state, action) => {
        if (state.loadingCount > 0 && !isExcluded(action)) {
          state.loadingCount -= 1;
        }
      })
      .addMatcher(isRejected, (state, action) => {
        if (state.loadingCount > 0 && !isExcluded(action)) {
          state.loadingCount -= 1;
        }
      });
  },
});

export const { startLoading, stopLoading } = loadingSlice.actions;
export default loadingSlice;
